import React, { useState, useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => {
    return {
        wrapper: {
            position: 'fixed',
            top: 0,
            left: 0,
            opacity: 0,
            pointerEvents: 'none',
        },
    };
});
const TemporaryFont = ({ onRemove }) => {
    const { classes } = useStyles();
    useEffect(() => {
        const timer = setTimeout(() => {
            onRemove();
        }, 3000);
        return () => clearTimeout(timer);
    }, []);
    return React.createElement("div", { className: classes.wrapper },
        React.createElement("div", { className: "font-lato-regular" }, "font-lato-regular"),
        React.createElement("div", { className: "font-lato-medium" }, "font-lato-medium"),
        React.createElement("div", { className: "font-lato-semi-bold" }, "font-lato-semi-bold"),
        React.createElement("div", { className: "font-lato-bold" }, "font-lato-bold"),
        React.createElement("div", { className: "font-lato-black" }, "font-lato-black"),
        React.createElement("div", { className: "font-inter-regular" }, "font-inter-regular"),
        React.createElement("div", { className: "font-inter-medium" }, "font-inter-medium"),
        React.createElement("div", { className: "font-inter-semi-bold" }, "font-inter-semi-bold"),
        React.createElement("div", { className: "font-inter-bold" }, "font-inter-bold"),
        React.createElement("div", { className: "font-inter-black" }, "font-inter-black"));
};
const FontPreload = () => {
    const [showComponent, setShowComponent] = useState(true);
    return (React.createElement("div", null, showComponent && React.createElement(TemporaryFont, { onRemove: () => setShowComponent(false) })));
};
export default FontPreload;
